import AntTable from '../../components/AntTableFixedHeader/AntTable';
import AntButton from "../../components/AntButton/AntButton";
import { Col, Row } from "antd";
import useLearningPaths from "./useLearningPaths";
import AntSearch from '../../components/AntSearch/AntSearch';

const LearningPaths = () => {


  const{
  data,
  isFetching,
  updateFn,
  handleClick,
  deleteFn,
  onChange,
  getSearchData
} = useLearningPaths()

  return (
        <Row justify="end" align="bottom" gutter={16}>
          <Col span={6}><AntSearch placeholder='Search'  getData={getSearchData} /></Col>
          <Col span={2}><AntButton type={"primary"} text={'Create'} size={'large'} color={"#185993"}  onClick={()=>{handleClick()}}/></Col>
          <Col item xs={24}>
          <AntTable data={data} updateFn={updateFn} deleteFn={deleteFn} onChange={onChange} isFetching={isFetching} />
          </Col>
        </Row>
  );
};

export default LearningPaths;
